import React from 'react';
import { Table, TableHead, TableProps } from '@mui/material';

// Keep one accessible table and one set of editors at every viewport size.
// On narrow screens each row becomes a labelled card instead of squeezed columns.
function plainText(node: React.ReactNode): string {
    return React.Children.toArray(node).map(child => {
        if (typeof child === 'string' || typeof child === 'number') return String(child);
        return React.isValidElement<{ children?: React.ReactNode }>(child) ? plainText(child.props.children) : '';
    }).join('');
}
export default function ResponsiveTable({ children, sx, ...props }: TableProps) {
    const head = React.Children.toArray(children).find(child => React.isValidElement(child) && child.type === TableHead) as React.ReactElement | undefined;
    const row = React.Children.toArray(head?.props.children)[0] as React.ReactElement | undefined;
    const labels = React.Children.toArray(row?.props.children).map(cell => plainText(cell) || 'Acciones');
    const mobile = {
        '@media (max-width: 1199.95px)': {
            display: 'block', width: '100%', minWidth: 0,
            '& thead': { display: 'block', position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', clipPath: 'inset(50%)' },
            '& tbody': { display: 'block', width: '100%' },
            '& tbody tr': { display: 'block', border: '1px solid #e0e6ef', borderRadius: 2, mb: 2, p: 1, bgcolor: 'white' },
            '& tbody td': { display: 'block', width: 'auto', minWidth: 0, textAlign: 'left', px: 1, py: 1, overflowWrap: 'anywhere', border: 0, fontSize: 14 },
            '& tbody td::before': { display: 'block', fontSize: 12, fontWeight: 600, color: '#526173', mb: 0.5 },
            ...Object.fromEntries(labels.map((label, index) => [`& tbody td:nth-of-type(${index + 1})::before`, { content: JSON.stringify(label) }])),
            '& tbody td[colspan]::before': { display: 'none' },
            '& .MuiFormControl-root': { width: '100%', minWidth: 0 },
            '& .MuiCheckbox-root': { p: 1, minWidth: 44, minHeight: 44 },
        },
    };
    return <Table {...props} sx={[...(Array.isArray(sx) ? sx : sx ? [sx] : []), mobile]}>{children}</Table>;
}
